export default __webpack_public_path__ + "static/media/almaz-mangisto.f3396d95.png";